import { Component, Inject, OnInit } from '@angular/core';
import { Plan } from '../../models/plan.model';
import { CookieCiencuadras } from '../../utils/cookie-ciencuadras/cookie-ciencuadras';
import { ProductsService } from '../../services/products/products.service';
import { CardColor } from '../../utils/card-color/card-color';
import { HttpErrorResponse } from '@angular/common/http';
import { DetailModal } from '../../models/detailModal.model';
import { environment } from '@env/environment';
import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { CcLoginComponent, CcRegisterComponent, PasswordRecoverComponent } from 'cc-components-lib';
import { WarningMessageModalComponent } from '../components/warning-message-modal/warning-message-modal.component';
import { isScullyRunning } from "@scullyio/ng-lib";
import { ActivatedRoute } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { CLARITY_SCRIPT, UserType } from '../../constants/constants';
import { ClarityService } from '../../services/clarity/clarity.service';

@Component({
  selector: 'app-products-ideal',
  templateUrl: './products-ideal.component.html',
  styleUrls: ['./products-ideal.component.scss']
})
export class ProductsIdealComponent implements OnInit {

  plans: Plan[] = [];
  planType: number = 0;
  clientType: string = '';
  idClientType: string = '';
  typeUser: string = '';
  listParent: any = [];
  textTitle!: string;
  textMessageModal: string = 'Estas intentando comprar un plan que no está asociado a tu tipo usuario, te dirigiremos a los planes que tenemos disponibles para ti';
  public ccEnvironment: any;
  MesesPlanArray: any = [];
  typeClient: string | undefined;
  titleSticky: string | undefined;

  constructor(
    @Inject(DOCUMENT) private tag: any,
    private cookieCiencuadras: CookieCiencuadras,
    private productsService: ProductsService,
    private cardColor: CardColor,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private clarityService : ClarityService
  ) {
    this.typeClient = this.route.snapshot.data['pageData'];
    if(this.typeClient){
      this.clarityService.loadClarity(CLARITY_SCRIPT);
    }
    this.textTitle = this.productsService.getTitleByUserType(this.typeClient);
    this.ccEnvironment = environment;
  }


  ngOnInit(): void {
    this.planType = parseInt(this.cookieCiencuadras.getCookie('planType'));
    this.clientType = this.cookieCiencuadras.getCookie('clientType');
    this.idClientType = this.cookieCiencuadras.getCookie('idClientType');
    this.typeUser = this.cookieCiencuadras.getCookie('typeUser');
    const loginUserType = this.cookieCiencuadras.getCookie('loginUserType');
    this.titleSticky = loginUserType == UserType.RealEstate.toString() ? 'una inmobiliaria nueva' : 'un agente inmobiliario nuevo';
    this.cookieCiencuadras.removeCookie('selectedPlan');
    if(!isScullyRunning()){
      if(!localStorage.getItem('clientType')){
        this.dialog.closeAll();
      }else if(localStorage.getItem('clientType') !== this.idClientType && this.typeUser !== ""){
        this.openInfoDialog();
      }else{
        this.dialog.closeAll();
      }
    }

    if (this.clientType != undefined && this.clientType != '') {
      this.productsService.getPlans(this.clientType).subscribe(res => {
        let data = res.result;
        if (res.status === "ok") {
          this.setDataPlans(data);
          this.setDataPlanHijos(data);
        }
      }, (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log('An error occurred:', err.error.message);
        } else {
          console.log('Backend returned status code: ', err.status);
          console.log('Response body:', err.error);
        }
      });
    } 
  }

  setDataPlans(data: any) {
    for (let i = 0; i < data.length; i++) {
      let discountPrice = 0;
      let colorCard = '';
      if (data[i].tipoPlanNumero === this.planType) {
        if (this.clientType === '3' && data[i].mesesVigenciaNumero === 12) {
          colorCard = 'bg-gradient-blue-2';
        }
        else if (this.clientType === '3' && data[i].mesesVigenciaNumero !== 12) {
          colorCard = 'bg-gradient-blue-3';
        }
        else {
          colorCard = this.cardColor.getCardColorBlue(parseInt(data[i].precio), this.clientType);
        }
        if (data[i].porcentajeDescuentoNumero > 0 && data[i].porcentajeDescuentoNumero !== null) {
          discountPrice = data[i].precio - (data[i].precio * data[i].porcentajeDescuentoNumero / 100);
        } else {
          discountPrice = data[i].precio;
        }
        let products: string[] = [];
        products = data[i].caracteristicasPlan ? data[i].caracteristicasPlan.split(";") : "";

        let urlName = '';
        let url = '';

        let relevantChar: string[] = [];
        if (data[i].caracteristicasRelevantes !== undefined && data[i].caracteristicasRelevantes !== null) {
          relevantChar = data[i].caracteristicasRelevantes.split(";");
        }
        if (data[i].visibleTarjeta == 1) {
          let detail: DetailModal = {
            name: data[i].nombre,
            price: data[i].precio,
            validity: data[i].mesesVigenciaNumero,
            validityLabel: data[i].etiquetaVigenciaServicio,
            priceLabel: data[i].etiquetaPrecioDetalle,
            topDescription: data[i].descripcionSuperiorDetalle,
            relevantCharacteristics: relevantChar,
            terms: data[i].terminosDetalle,
            aditionalInfoHTML: data[i].informacionAdicionalHtml,
            urlName: urlName,
            url: url,
            duration: data[i].tiempoDuracionNumero,
            unitTimeDuration: data[i].unidadTiempoNumero,
            duratrionLabel: data[i].descripcionDuracionProducto,
            image_url: data[i].imagenEstatica + '-detalle',
            discount: data[i].porcentajeDescuentoNumero,
            priceDiscount: discountPrice,
            type: 'plan'
          }
          let plan: Plan = {
            external_product_id: Date.now().toString(),
            carritoId: data[i].carritoId,
            token: "",
            id: data[i].id,
            name: data[i].nombre,
            summary: products,
            price: data[i].precio,
            basePrice: data[i].precioBase,
            descriptionValuePlan: data[i].descripcionValorPlan,
            stock: data[i].stock,
            available_stock: data[i].disponibleStock,
            image_url: data[i].imagenEstatica,
            image_alt: data[i].altImagen,
            iva: data[i].iva,
            priceIva: data[i].ivaPrecio,
            idClientType: this.clientType,
            discount: data[i].porcentajeDescuentoNumero,
            priceDiscount: discountPrice,
            validity: data[i].mesesVigenciaNumero,
            unit_validity: data[i].unidadVigencia,
            colorCard: colorCard,
            termsDescription: data[i].descripcionTerminos,
            detailModal: detail,
            includedProducts: data[i].productoDTOList,
            visibleTarjeta: data[i].visibleTarjeta,
            cod: data[i].codigo
          };
          this.plans.push(plan);
        }
      }
    }
    if (this.clientType !== '3') {
      this.plans.sort(this.dynamicSort("price"));
    }
  }

  dynamicSort(property: string) {
    var sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a: any, b: any) {
      /* next line works with strings and numbers, 
       * and you may want to customize it to your needs
       */
      var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  setDataPlanHijos(data: any) {
    this.plans.forEach(parent => {
      let Arraymount = [];
      let index = 0;
      data.forEach(children => {
        if (children.visibleTarjeta === 0) {
          let cod = children.codigo.split("-");
          if (cod[0] == parent.cod) {
            let newObject = this.convertToParent(children);
            let obj = {
              "id": parent.id,
              "cod": parent.cod,
              "data": [
                children
              ]
            }
            this.listParent.push(obj);
            Arraymount.push(newObject);
            index++;
          }
        }
      });
      parent.meses = Arraymount;
    });
  }

  convertToParent(children) {
    let relevantChar;
    let discountPrice = children.precio;
    let products: string[] = [];
    products = children.caracteristicasPlan ? children.caracteristicasPlan.split(";") : "";
    let colorCard = '';
    if (this.clientType === '3' && children.mesesVigenciaNumero === 12) {
      colorCard = 'bg-gradient-blue-2';
    }
    else if (this.clientType === '3' && children.mesesVigenciaNumero !== 12) {
      colorCard = 'bg-gradient-blue-3';
    }
    else {
      colorCard = this.cardColor.getCardColorBlue(parseInt(children.precio), this.clientType);
    }
    if (children.caracteristicasRelevantes !== undefined && children.caracteristicasRelevantes !== null) {
      relevantChar = children.caracteristicasRelevantes.split(";");
    }
    let detail: DetailModal = {
      name: children.nombre,
      price: children.precio,
      validity: children.mesesVigenciaNumero,
      validityLabel: children.etiquetaVigenciaServicio,
      priceLabel: children.etiquetaPrecioDetalle,
      topDescription: children.descripcionSuperiorDetalle,
      relevantCharacteristics: relevantChar,
      terms: children.terminosDetalle,
      aditionalInfoHTML: children.informacionAdicionalHtml,
      urlName: '',
      url: '',
      duration: children.tiempoDuracionNumero,
      unitTimeDuration: children.unidadTiempoNumero,
      duratrionLabel: children.descripcionDuracionProducto,
      image_url: children.imagenEstatica + '-detalle',
      discount: children.porcentajeDescuentoNumero,
      priceDiscount: discountPrice,
      type: 'plan',
    }
    let plan: Plan = {
      external_product_id: Date.now().toString(),
      carritoId: children.carritoId,
      token: "",
      id: children.id,
      name: children.nombre,
      summary: products,
      price: children.precio,
      basePrice: children.precioBase,
      descriptionValuePlan: children.descripcionValorPlan,
      stock: children.stock,
      available_stock: children.disponibleStock,
      image_url: children.imagenEstatica,
      image_alt: children.altImagen,
      iva: children.iva,
      priceIva: children.ivaPrecio,
      idClientType: this.clientType,
      discount: children.porcentajeDescuentoNumero,
      priceDiscount: discountPrice,
      validity: children.mesesVigenciaNumero,
      unit_validity: children.unidadVigencia,
      colorCard: colorCard,
      termsDescription: children.descripcionTerminos,
      detailModal: detail,
      includedProducts: children.productoDTOList,
      visibleTarjeta: children.visibleTarjeta,
      cod: children.codigo
    };
    return plan;
  }

  openInfoDialog(){
    const infoConfig = new MatDialogConfig();
    infoConfig.panelClass = 'detail-modal';
    infoConfig.maxWidth = '100vw';    
    infoConfig.hasBackdrop = true;
    infoConfig.disableClose = true;
    this.dialog.open(WarningMessageModalComponent, infoConfig);
  }

  OpenOnboardingModal(Onboarding: any) {
    this.dialog.closeAll();
    if (Onboarding.modal == 1) {
      console.log("Onboarding.modal-->", Onboarding.modal);
      this.OpenLoginModal(Onboarding.typeUser);
    }
    if (Onboarding.modal == 2) {
      this.OpenRecoverPwModal(Onboarding.typeUser);
    }
    if (Onboarding.modal == 3) {
      this.OpenRegisterModal(Onboarding.typeUser);
    }
  }

  OpenLoginModal(typeUser: string) {
    let DialogRefLogin = this.dialog.open(CcLoginComponent, {
      data: { 'isModal': true, 'typeUser': typeUser },
      panelClass: 'onboardingModal'
    });
    DialogRefLogin.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRecoverPwModal(typeUser: string) {
    let DialogRefRecover = this.dialog.open(PasswordRecoverComponent, {
      data: { 'isModal': true, 'typeUser': typeUser },
      panelClass: 'onboardingModal'
    });
    DialogRefRecover.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }

  OpenRegisterModal(typeUser: string) {
    let DialogRefRegister = this.dialog.open(CcRegisterComponent, {
      data: { 'isModal': true, 'typeUser': typeUser },
      panelClass: 'onboardingModal'
    });
    DialogRefRegister.componentInstance.OpenOnboardingModalEvent.subscribe((res: any) => {
      this.OpenOnboardingModal(res);
    });
  }
}